var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLink = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.25 10a2.586 2.586 0 0 1 2.583-2.583h3.334V5.833H5.833A4.168 4.168 0 0 0 1.667 10c0 2.3 1.866 4.167 4.166 4.167h3.334v-1.584H5.833A2.586 2.586 0 0 1 3.25 10Zm3.417.833h6.666V9.167H6.667v1.666Zm7.5-5h-3.334v1.584h3.334A2.586 2.586 0 0 1 16.75 10a2.586 2.586 0 0 1-2.583 2.583h-3.334v1.584h3.334c2.3 0 4.166-1.867 4.166-4.167s-1.866-4.167-4.166-4.167Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
};
export { SvgLink as ReactComponent };